import ox from '$/ox'
import $ from '$/jquery'
import _ from '$/underscore'
import ext from '$/io.ox/core/extensions'
import gt from 'gettext'
import Dropdown from '$/io.ox/backbone/mini-views/dropdown'
import { getCmpReady, openManageCookies, pushAd } from '@/uk.co.talktalk/tradehouse/cmp'

import '@/uk.co.talktalk/login/login.scss'

ext.point('io.ox/login/navbar').extend({
  id: 'header',
  index: 'first',
  draw: function () {
    this.append(
      $('<div class="row login-top-bar">').append(
        $('<div class="header-logo">').append(
          $('<a href="http://talktalk.co.uk">').append(
            $('<img alt="TalkTalk logo" src="' + ox.root + '/themes/uk.co.talktalk/talktalk_logo.png">')
          )
        )
      )
    )
  }
}, {
  id: 'navigation',
  index: 'last',
  draw: function () {
    const $dropdownToggle = $('<a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-label="Navigation" aria-expanded="false">').append(
      $('<svg width="16" height="16" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-list larger" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"></path></svg')
    )
    const $dropdownMenu = $('<ul class="dropdown-menu custom-dropdown" role="menu">').append(
      $('<li>').append(
        $('<a href="http://myaccount.talktalk.co.uk/">').text(gt('My TalkTalk'))
      ),
      $('<li>').append(
        $('<a href="https://www.talktalk.co.uk/shop/">').text(gt('TV, Broadband & Calls'))
      ),
      $('<li>').append(
        $('<a href="https://safeavenue.f-secure.com/iframe/-sso/talktalk/">').text(gt('SuperSafe'))
      ),
      ox.serverConfig.faktorURL
        ? $('<li>').append(
          $('<a href="#" role="menuitem">').on('click', function (e) {
            e.preventDefault()
            openManageCookies()
          }).text(gt('Manage Cookies'))
        )
        : $(),
      $('<li class="divider">'),
      $('<li>').append(
        $('<a href="https://newmail.talktalk.co.uk/help/?utm_source=TTM&utm_medium=help-button">').text(gt('Help'))
      ),
      $('<li>').append(
        $('<a href="http://community.talktalk.co.uk/accessibility?from_footer_nav">').text(gt('Accessibility'))
      ),
      $('<li>').append(
        $('<a href="http://www.talktalk.co.uk/legal/code-of-practice?from_footer_nav">').text(gt('Code of practice'))
      ),
      $('<li>').append(
        $('<a href="https://community.talktalk.co.uk/t5/Articles/How-do-I-make-a-complaint/ta-p/2204670?from_footer_nav">').text(gt('Customer complaints code '))
      ),
      $('<li>').append(
        $('<a href="http://www.talktalk.co.uk/legal?from_footer_nav">').text(gt('Legal'))
      ),
      $('<li>').append(
        $('<a href="http://www.talktalk.co.uk/legal/privacy-policy?from_footer_nav">').text(gt('Privacy Policy'))
      ),
      $('<li>').append(
        $('<a href="http://www.talktalk.co.uk/legal/terms?from_footer_nav">').text(gt('Terms & Conditions'))
      ),
      $('<li>').append(
        $('<a href="http://www.talktalk.co.uk/legal/cookie-policy">').text(gt('Cookies and our policy'))
      )
    )
    const dropdown = new Dropdown({
      className: 'dropdown',
      $toggle: $dropdownToggle,
      $ul: $dropdownMenu,
      title: ''
    })

    this.find('.login-top-bar').append(
      $('<nav class="pull-right">').append(
        $('<ul class="nav navbar-right">').append(
          $('<li role="presentation">').append(
            $('<ul class="top-nav">').append(
              $('<li role="presentation">').append(
                $('<a target="_blank" href="https://newmail.talktalk.co.uk/help/?utm_source=TTM&utm_medium=help-butto">').append(
                  $('<svg width="16" height="16" aria-hidden="true" class="launcher-icon bi bi-question-circle" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"></path></svg>')
                )
              ),
              $('<li role="presentation" class="dropdown">').append(
                dropdown.render().$el
              )
            )
          )
        )
      )
    )
  }
}, {
  id: 'ads_top',
  index: 'last',
  draw: function () {
    const adClass = !_.device('smartphone') ? 'display-login-top' : 'display-login-top-mobile'
    this.append(
      $('<div class="row">').append(
        $('<div class="col-xs-12">').append(
          $('<div>').addClass([adClass, 'io-ox-ads-logout'].join(' '))
        )
      )
    )
    // Create Tradehouse ad slot divs
    if (_.device('smartphone')) {
      $('.display-login-top-mobile').append(
        $('<span>').addClass('display-label').text(gt('Advertisement')),
        $('<div id="MBdFs6cFeMSiVIFS1F9U">')
      )
      pushAd(['{ "tagid": "MBdFs6cFeMSiVIFS1F9U", "alias": "/", "type": "banner", "zid": "505", "pid": "0", "iframe": "true", "width": "320", "height": "50", "refresh": "30", "refresh_limit": "15" }'])
    } else {
      $('.display-login-top').append(
        $('<span>').addClass('display-label').text(gt('Advertisement')),
        $('<div id="EWvDBP37qQw0PhGcxJwS">')
      )
      pushAd(['{ "tagid": "EWvDBP37qQw0PhGcxJwS", "alias": "/", "type": "banner", "zid": "506", "pid": "0", "iframe": "true", "width": "728", "height": "90", "refresh": "30", "refresh_limit": "15" }'])
    }
  }
}, {
  id: 'audience_pixel',
  index: 'last',
  draw: function () {
    $('body').append($('<div>').attr('id', 'bNsm89ueUddglAE1vKOj'))
    pushAd(['{ "tagid": "bNsm89ueUddglAE1vKOj", "alias": "/", "type": "banner", "zid": "630", "pid": "0", "iframe": "true", "width": "1", "height": "1", "refresh": "559", "refresh_limit": "0" }'])
    if (getCmpReady() && window.AVP) window.AVP.load()
  }
})

// Advertisement integration
ext.point('io.ox/login/body').extend({
  id: 'copy',
  index: 100,
  draw: function () {
    const loginImageUrl = 'themes/uk.co.talktalk/images/spam.png'
    const findOutMoreUrl = ox.serverConfig.find_out_more_url || 'https://community.talktalk.co.uk/t5/Articles/Using-TalkTalk-Mail/ta-p/2204440?advanced=false&collapse_discussion=true&filter=includeTkbs&include_tkbs=true&q=talktalk%20mail&search_type=thread'

    if (_.device('smartphone')) return

    this.prepend(
      $('<div class="col-sm-6 col-md-8" id="io-ox-login-left-content">').append(
        $('<div class="row">').append(
          $('<div class="col-xs-12">').append(
            $('<div class="title">').text(gt('Login to discover your new TalkTalk Mail today'))
          )
        ),
        $('<div class="row notification">').append(
          $('<div class="col-xs-12 col-md-6">').append(
            $('<div class="subtitle">').text(
              gt('We\'ve made TalkTalk Mail better and even easier to use')
            ),
            $('<div class="message">').html(
              gt('We\'ve introduced features you\'ve been asking for. Your email now has a dedicated spam button to help improve your spam filters and protect you from scams. When you receive a spam message just click <b>\'Mark as spam\'</b> link to update your spam filters')
            ),
            $('<a>').attr('href', findOutMoreUrl).text(
              gt('Find out more')
            )
          ),
          $('<div class="col-xs-12 col-md-6">').append(
            $('<img>').attr('src', loginImageUrl).addClass('mark-as-spam')
          )
        )
      )
    )
  }
}, {
  id: 'desktop_ads_bottom',
  index: 200,
  draw: function () {
    if (_.device('smartphone')) return
    this.find('#io-ox-login-left-content').append(
      $('<div>').addClass('ad-login-bottom').append(
        $('<span>').addClass('display-label').text(gt('Advertisement')),
        $('<div id="bvafzhc7DOaUFMyfnLVF">')
      )
    )
    pushAd(['{ "tagid": "bvafzhc7DOaUFMyfnLVF", "alias": "/", "type": "banner", "zid": "607", "pid": "0", "iframe": "true", "width": "1", "height": "1", "refresh": "999", "refresh_limit": "0" }'])
  }
})

ext.point('io.ox/login/footer').extend({
  id: 'mobile_ads_bottom',
  index: 'last',
  draw: function () {
    if (!_.device('smartphone')) return
    this.append(
      $('<div class="row">').append(
        $('<div class="col-xs-12">').append(
          $('<div>').addClass('ad-login-bottom-mobile').append(
            $('<span>').addClass('display-label').text(gt('Advertisement')),
            $('<div id="bvafzhc7DOaUFMyfnLVF">')
          )
        )
      )
    )
    pushAd(['{ "tagid": "bvafzhc7DOaUFMyfnLVF", "alias": "/", "type": "banner", "zid": "607", "pid": "0", "iframe": "true", "width": "1", "height": "1", "refresh": "999", "refresh_limit": "0" }'])
  }
})

async function getCloseIconSVG () {
  const response = await fetch('./themes/default/icons/bi/x.svg')
  if (!response.ok) {
    console.error('Could not load SVG for mobile dropdown close icon')
    return '<svg width="1px" height="1px" version="1.1" xmlns="http://www.w3.org/2000/svg"></svg>'
  }
  return response.text()
}

const loginScreen = $('#io-ox-login-screen')

async function addCloseIconSVG () {
  if (!loginScreen.is(':visible')) {
    ext.point('io.ox/core/dropdown').disable('top-header-svg-icon')
    return
  }
  const closeIconSvgText = await getCloseIconSVG()
  const closeIconSvgContainer = this.$ul.find('li.close-button > button > div')
  closeIconSvgContainer.empty().append($(closeIconSvgText).addClass('bi-24'))
}

// Add close button to dropdowns on login page on mobile
if (_.device('smartphone')) {
  ext.point('io.ox/core/dropdown').extend({
    id: 'top-header-svg-icon',
    after: 'top-header',
    draw: addCloseIconSVG,
    redraw: addCloseIconSVG
  })
}
